"use client";

import { useEffect, useRef } from "react";
import { useToast } from "@/src/contexts/toastContext";
import { useNewVersionAvailable } from "@/src/hooks/useNewVersionAvailable";

// Mount once near the root. Renders nothing itself -- when a new deploy is
// detected (see useNewVersionAvailable), pushes a persistent toast with a
// Refresh action. Doesn't auto-reload: forcing a reload out from under
// someone mid-generation or mid-typing would be its own bad experience.
export default function NewVersionWatcher() {
  const available = useNewVersionAvailable();
  const { push } = useToast();
  const shown = useRef(false);

  useEffect(() => {
    if (!available || shown.current) return;
    shown.current = true;
    push({
      title: "A new version of Quarkle is available",
      description: "Refresh to update.",
      kind: "info",
      duration: null,
      action: { label: "Refresh", onClick: () => window.location.reload() },
    });
  }, [available, push]);

  return null;
}
